<template>
  <v-container grid-list-xs fluid>
    <v-row row wrap justify="center">
      <v-col class="col-8">
        Would you like to share this notification with colleagues?
      </v-col>
      <v-col class="col-4">
        <v-radio-group
          v-model="notification.shareWithColleagues"
          row
          class="mt-0 pt-0"
        >
          <v-radio label="Yes" value="yes"></v-radio>
          <v-radio label="No" value="no"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row
      v-if="notification.shareWithColleagues === 'yes'"
      row
      wrap
      justify="center"
    >
      <v-col class="col-8">
        Which colleagues would you like to share the notification with?
      </v-col>
      <v-col class="col-4">
        <Loader
          v-if="loadingUsers"
          size="small"
          text="Loading colleagues"
        ></Loader>
        <span v-if="!loadingUsers && !hasGroupMembers">
          No colleagues found
        </span>
        <v-autocomplete
          v-if="hasGroupMembers"
          v-model="notification.selectedMembers"
          :items="userGroupMembers"
          :filter="customFilter"
          :error-messages="showError"
          small-chips
          multiple
          deletable-chips
          clearable
          item-text="email"
          return-object
          label="Select colleagues to share with"
          class="mt-0 pt-0"
          @change="handleChangeMembers"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashSortBy from "lodash/sortBy";
import lodashSortedUniq from "lodash/sortedUniq";

import { mapGetters } from "vuex";
import { GET_GROUP_MEMBERS } from "@/store/actions.type";
import { MODULE_PREFIX_USER } from "@/store";
import { getUserProfile } from "@/common/storage";
import {
  updateStoreStep,
  extractDetailsFromSavedSearch,
} from "@/services/search/savedSearch.service";

export default {
  name: "NotificationsStepShare",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    refresh: {
      type: String,
    },
  },
  data() {
    const notification = {};
    notification.selectedMembers = [];
    notification.shareWithColleagues = "no";

    return {
      notification: notification,
      currentUser: null,
      userGroupMembers: [],
      loadingUsers: true,
    };
  },
  computed: {
    ...mapGetters({
      groupMembers: MODULE_PREFIX_USER + "groupMembers",
    }),
    hasGroupMembers() {
      return this.userGroupMembers.length > 0;
    },
    showError() {
      if (
        this.notification.selectedMembers &&
        this.notification.selectedMembers.length > 0
      ) {
        return null;
      }
      return "At least one colleague must be selected";
    },
  },
  async mounted() {
    this.currentUser = getUserProfile();
    await this.loadUserGroupMembers();
    this.handleChangeShareWithColleagues();
    extractDetailsFromSavedSearch(this.notification, "sharing");
    this.update();
  },
  methods: {
    async loadUserGroupMembers() {
      this.loadingUsers = true;
      await this.$store.dispatch(MODULE_PREFIX_USER + GET_GROUP_MEMBERS);
      this.loadingUsers = false;
      if (this.groupMembers.length <= 0) {
        return;
      }

      const SORTED = lodashSortBy(this.groupMembers, "email");
      const SORTED_UNIQUE = lodashSortedUniq(SORTED, "email");
      let mapped = [];
      SORTED_UNIQUE.forEach((member) => {
        if (
          member.email.toLowerCase() !== this.currentUser.email.toLowerCase()
        ) {
          mapped.push({
            id: member.id,
            email: member.email.toLowerCase(),
          });
        }
      });
      this.userGroupMembers = mapped;
    },
    customFilter(item, queryText) {
      const SEARCH = queryText.toLowerCase();
      const TEXT = item.email.toLowerCase();
      return TEXT.indexOf(SEARCH) > -1;
    },
    update() {
      updateStoreStep(this.notification, "sharing");
    },
    handleChangeMembers() {
      this.update();
    },
    handleChangeShareWithColleagues() {
      if (this.notification.shareWithColleagues === "no") {
        this.notification.selectedMembers = [];
      }
      this.update();
    },
  },
  watch: {
    "notification.shareWithColleagues": {
      handler() {
        this.handleChangeShareWithColleagues();
      },
    },
    refresh() {
      extractDetailsFromSavedSearch(this.notification, "sharing");
      this.update();
    },
  },
  beforeDestroy() {},
};
</script>

<style scoped></style>
